<script setup lang="ts">
interface CardContainerProps {
  ContainerTitle: string;
}

// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<CardContainerProps>(), {
  ContainerTitle: 'Planos',
});
</script>

<template>
  <div
    :style="{ background: 'radial-gradient(55.79% 86.9% at 44.51% 32.48%, #254689 0%, #253170 100%)' }"
    class="flex h-max w-full flex-col items-center justify-center p-8 md:p-32 overflow-hidden"
  >
    <h2
      v-if="ContainerTitle"
      :style="{ letterSpacing: '0.095em' }"
      class="font-Open text-4xl mb-16 font-bold text-white"
    >
      {{ ContainerTitle }}
    </h2>
    <slot></slot>
  </div>
</template>
